//export * from './<module>'
export * from './confirmar';
import * as Invitado_1 from './invitado';
export { Invitado_1 as Invitado };
